import { render, staticRenderFns } from "./_DetailsToolbarContent.vue?vue&type=template&id=723d9b57&"
import script from "./_DetailsToolbarContent.vue?vue&type=script&lang=js&"
export * from "./_DetailsToolbarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports